<template>
    <div id="page-content-wrapper" class="admin-content-area">
        <template v-if="cantAccessPage === true">
            <div class="container-fluid xyz">
                <div class="page-header-top-container">
                    <div id="lienHeader" class="page-name color-71aa3f">
                        Create Lien
                    </div>
                    <button type="submit" class="btn general-button btn-primary" v-on:click.prevent="backshowlien">Back</button>
                </div>
                <div v-if="isDataEditable == true">
                    <div class="admin-page-content">
                        <form id="lienform">
                            <div class="forms-container">
                                <div class="row no-margin">
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 hide">
                                        <div class="alert alert-success" id="alertSuccess">
                                            <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                            <span>Lien Added Successfully</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 hide">
                                        <div class="alert alert-danger" id="alertError">
                                            <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                            <span id="errorMsg" class="error"></span>
                                        </div>
                                    </div>


                                    <div class="col-md-6 col-sm-12">
                                      <!-- CUSTOMER -->
                                      <div class="col-12 forms-block">
                                          <div class="col-3 paddingleft0">
                                              <div class="form-label"><strong>Customer</strong></div>
                                          </div>
                                          <div class="col-9 paddingleft0">
                                              <v-select v-model="customer_id"
                                              @change="changedValue" name="customer_id"
                                                        label="text"
                                                        :filterable="false"
                                                        :options="customerArr"
                                                        @search="onSearch"
                                                        v-validate="'required'"
                                                        placeholder="Select Customer">
                                                  <template slot="no-options">
                                                      Search Customers...
                                                  </template>
                                                  <template slot="option" slot-scope="option">
                                                      <div class="d-center">
                                                          {{ option.text }}
                                                      </div>
                                                  </template>
                                                  <template slot="selected-option" slot-scope="option">
                                                      <div class="selected d-center">
                                                          {{ option.text }}
                                                      </div>
                                                  </template>
                                              </v-select>
                                              <div class="requiredstar">*</div>
                                              <span v-show="errors.has('customer_id')" class="help is-danger" v-if="errors.has('customer_id')"><font color="red">Customer is Required</font></span>
                                          </div>
                                      </div>
                                    </div>
                                    <div class="col-md-6 col-sm-12">
                                        <div class="col-12 forms-block">
                                            <div class="col-3 paddingleft0">
                                                <div class="form-label"><strong>RO#</strong></div>
                                            </div>
                                            <div class="col-9 paddingleft0">
                                                <input type="text" id="ro_number" name="ro_number" class="form-control"
                                                      placeholder="Enter RO Number" v-model="ro_number">
                                                <span v-show="roErr.tooLong" class="help is-danger">
                                                    <font color="red">RO number Exceeding {{ allowedLength }} character length</font>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-sm-12">

                                        <div class="col-12 forms-block">
                                            <div class="col-3 paddingleft0">
                                                <div class="form-label"><strong>Serial#</strong></div>
                                            </div>
                                            <div class="col-9 paddingleft0">
                                                <input type="text" id="serial_number" v-validate="'required'" name="serial_number" class="form-control"
                                                      placeholder="Enter Serial Number" v-model="serial_number">
                                                <div class="requiredstar">*</div>
                                                <span v-show="errors.has('serial_number')" class="help is-danger" v-if="errors.has('serial_number')"><font color="red">Serial# is Required</font></span>
                                                <span v-show="serialErr.tooLong" class="help is-danger">
                                                    <font color="red">Serial number Exceeding {{ allowedLength }} character length</font>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-sm-12">
                                        <div class="col-12 forms-block">
                                            <div class="col-3 paddingleft0">
                                                <div class="form-label"><strong>Lien#</strong></div>
                                            </div>
                                            <div class="col-9 paddingleft0">
                                                <input type="text" id="lien_number" v-validate="'required'" name="lien_number" class="form-control"
                                                      placeholder="Enter Lien Number" v-model="lien_number">
                                                <div class="requiredstar">*</div>
                                                <span v-show="errors.has('lien_number')" class="help is-danger" v-if="errors.has('lien_number')"><font color="red">Lien# is Required</font></span>
                                                <span v-show="lienErr.tooLong" class="help is-danger">
                                                    <font color="red">Lien number Exceeding {{ allowedLength }} character length</font>
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-6 col-sm-12">
                                        <div class="col-12 forms-block">
                                            <div class="col-3 paddingleft0">
                                                <div class="form-label"><strong>Lien Amount</strong></div>
                                            </div>
                                            <div class="col-9 paddingleft0">
                                                <input type="text" id="lien_amount" v-validate="'required'" name="lien_amount" class="form-control"
                                                      placeholder="Enter Lien Amount" v-model="lien_amount">
                                                <div class="requiredstar">*</div>
                                                <span v-show="amtErrors.required" class="help is-danger">
                                                    <font color="red">Lien Amount is Required</font>
                                                </span>
                                                <span v-show="amtErrors.notNumber" class="help is-danger">
                                                    <font color="red">Lien Amount must be numeric</font>
                                                </span>
                                                <span v-show="amtErrors.tooLarge" class="help is-danger">
                                                    <font color="red">Lien Amount must not exceed 1,000,000</font>
                                                </span>
                                                <!-- <span v-show="errors.has('lien_amount')" class="help is-danger" v-if="errors.has('lien_amount')"><font color="red">Lien Amount is Required</font></span> -->
                                            </div>
                                            
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-sm-12">
                                        <div class="col-12 forms-block">
                                            <div class="col-3 paddingleft0">
                                                <div class="form-label"><strong>Issue Date</strong></div>
                                            </div>
                                            <div class="col-9 paddingleft0">
                                                <input type="date" id="issue_date" v-validate="'required'" name="issue_date" class="form-control"
                                                      placeholder="Enter Date in MM/DD/YYYY" v-model="issue_date">
                                                <div class="requiredstar">*</div>
                                                <span v-show="errors.has('issue_date')" class="help is-danger" v-if="errors.has('issue_date')"><font color="red">liens Issue Date is Required</font></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-sm-12">
                                        <!-- EXP DATE -->
                                        <div class="col-12 forms-block">
                                            <div class="col-3 paddingleft0">
                                                <div class="form-label"><strong>Expiration Date</strong></div>
                                            </div>
                                            <div class="col-9 paddingleft0">
                                                <input type="date" id="expiry_date" v-validate="'required'" name="expiry_date" class="form-control"
                                                      placeholder="Enter Date in MM/DD/YYYY" v-model="expiry_date">
                                                <div class="requiredstar">*</div>
                                                <span v-show="errors.has('expiry_date')" class="help is-danger" v-if="errors.has('expiry_date')"><font color="red">liens Expiration Date is Required</font></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-sm-12">
                                        <div class="col-12 forms-block">
                                            <div class="col-3 paddingleft0">
                                                <div class="form-label"><strong>Status</strong></div>
                                            </div>
                                            <div class="col-9 paddingleft0">
                                                <v-select
                                                    name="status"
                                                    v-model="status"
                                                    id="status" label="text"
                                                    :options="statusArr"
                                                    :required="true"
                                                    v-validate="'required'"></v-select>
                                                <div class="requiredstar">*</div>
                                                <span v-show="errors.has('status')" class="help is-danger"><font color="red">Status is Required</font></span>
                                            </div> 
                                        </div>   
                                    </div>

                                    <div class="col-md-6 col-sm-12">
                                        <div class="mobile-created-data col-md-6 ml-sm-12 forms-block">
                                            <div class="col-12 paddingleft0">
                                                <div class="form-label"><strong>Created By</strong> : {{ firstName }} {{ lastName }}</div>
                                            </div>
                                        </div>


                                        <div class="mobile-created-data col-md-6 ml-sm-12 forms-block">
                                            <div class="col-12 paddingleft0">
                                                <div class="form-label"><strong>Created at</strong> : {{ created_at }}</div>
                                            </div>
                                        </div>



                                        <div v-if="is_update" class="mobile-created-data col-md-6 ml-sm-12 forms-block">
                                            <div class="col-12 paddingleft0">
                                                <div class="form-label"><strong>Updated By</strong> : {{ u_firstName }} {{ u_lastName }}</div>
                                            </div>
                                        </div>


                                        <div v-if="is_update" class="mobile-created-data col-md-6 ml-sm-12 forms-block">
                                            <div class="col-12 paddingleft0">
                                                <div class="form-label"><strong>Updated at</strong> : {{ updated_at }}</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-12 ml-3">
                                        <div class="col-12 paddingleft0">
                                            <input id="addlienBtn" type="submit" value="Save" class="btn general-button btn-primary" v-on:click.prevent="AddLien()">
                                            <input id="Cancellien" type="submit" value="Cancel" class="btn general-button btn-primary" v-on:click.prevent="backshowlien">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div v-if="isDataEditable == false" >
                    <div class="admin-page-content">
                        <div class="col-md-12 error-detail-main forms-container">
                            <div class="error-template">
                                <h1>Oops!</h1>
                                <!--<h2>403</h2>-->
                                <div class="error-details">Sorry You can't Edit This Record...</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="admin-page-content">
                <div class="col-md-12 error-detail-main forms-container">
                    <div class="error-template">
                        <h1>Oops!</h1>
                        <h2>403</h2>
                        <div class="error-details">Sorry!, You don't have permission to access this page.</div>
                    </div>
                </div>
            </div>
        </template>
        <app-footer></app-footer>
    </div>
</template>

<script>
    import index from "../../router";
    import Vue from "vue";
    import EventBus from "../event-bus";
    import FrontFooter from '@/components/partials/FrontFooter';
    import VeeValidate from "vee-validate";
    import SessioMixin from '../../mixins/sessionmixin';
    Vue.use(VeeValidate);
// import moment from 'moment'
    /* Vue FlatPickr */
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    var contex;
    export default {
        name: "AddLien",
        components: {
            'app-footer': FrontFooter,
            flatPickr,
        },
        mixins: [SessioMixin],
        data() {
            return {
                tempReason: '',
                is_update: false,
                created_at: '',
                updated_at: '',
                other_reason: '',
                ptTaxId: '',
                svTaxId: '',
                lien_number: '',
                lien_amount:'',
                ro_number:'',
                serial_number:'',
                expiry_date: "",
                issue_date: "",
                status: '',
                isShowLoggedinfields: true,
                firstName: "",
                lastName: "",
                u_firstName: "",
                u_lastName: "",
                userName: "",
                permissions: [],
                cantAccessPage: true,
                isLoggedIn: false,
                customerId: 0,
                created_by: "",
                updated_by: "",
                config: {
                    wrap: true, // set wrap to true only when using 'input-group'
                    altFormat: 'm/d/Y',
                    altInput: true,
                    dateFormat: 'Y-m-d',
                    enableTime: false,
                    //locale: Hindi, // locale for this instance only
                },
                priority: {value: "normal", text: "Normal"},
                status: {value: "active", text: "Active"},
                subject: "",
                description: "",

                statusArr: [
                    {
                        value: "active",
                        text: "Active"
                    },
                    {
                        value: "paid",
                        text: "Paid/Discharged"
                    },
                    {
                        value: "beyleft",
                        text: "Bailiff"
                    },
                    {
                        value: "beyleaves",
                        text: "Bailee’s"
                    }
                ],

                due_date: "",
                customer_id: "",
                options: "",
                customerArr: [],
                user_id: "",
                userArr: [],
                isDataEditable: true,
                loginID: "",
                amtErrors: {
                    required: false,
                    notNumber: false,
                    tooLarge:false
                },
                lienErr: {
                    tooLong:false
                },
                roErr: {
                    tooLong:false
                },
                serialErr: {
                    tooLong:false
                },
                allowedLength:18
            };
        },
        watch: {
            customer_id: function (customer_id) {
                var self = this;

                if(customer_id != null && customer_id != '') {
                }

                if (!self.$route.path.includes('update')) {
                    if (typeof (customer_id) == "undefined" || customer_id == null) {
                        self.user_id = {value: '', text: ''};
                    } else {
                        
                        if (customer_id == '') {
                            self.user_id = {value: '', text: ''};
                        } else {
                            $.ajax({
                                url: process.env.ROOT_API + "/get/customer/user",
                                type: "GET",
                                headers: {
                                    Accept: "application/json",
                                    "Access-Control-Allow-Origin": "*",
                                    Authorization: "Bearer " + localStorage.getItem("api_token"),
                                    "Access-Control-Allow-Headers":
                                            "Origin, Content-Type, Authorization,X-Requested-With",
                                    "Cache-Control": "no-cache"
                                },
                                data: {
                                    customer_id: customer_id.value
                                },
                                dataType: "json",
                                success: function (data) {
                                    if (customer_id.value) {
                                        self.user_id = {value: data[0].value, text: data[0].text};
                                        self.userArr = data;
                                    }
                                },
                                error: function (jqXHR, exception) {
                                    if (jqXHR.status == 0) {
                                        self.error = "Remote server can not be reachable";
                                    } else {
                                        if (jqXHR.status == 401) {
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            self.$router.push("/login");
                                        }
                                        self.error = jqXHR.responseJSON.message;
                                    }
                                }
                            });
                        }
                    }
                }
            }
        },
        beforeMount: function () {
            var app = this;
            contex = this;
            var check = localStorage.getItem("api_token");

            if (check != null) {
                app.isLoggedIn = true;
                app.getPermissions();
            }
        },
        mounted: function () {
            var self = this;

            $(".removeActive").removeClass("active");
            if (self.$route.path.includes('update')) {
                self.is_update = true;
                if (self.$route.params.from != 0) {
                    $("#menucustomers").addClass("active");
                } else {
                    $("#menulien").addClass("active");
                }
            } else {
                self.created_at = self.getCurrentDateTime('');
                if (self.$route.params.from != 0) {
                    $("#menucustomers").addClass("active");
                } else {
                    $("#menulien").addClass("active");
                }

                self.lien_reason = {
                  SettingValue: "lien Exemption",
                };
            }

            if (localStorage.getItem("menu_small") == "1") {
                self.menuSmall();
            } else {
                self.menuBig();
            }
            if (self.$route.path.includes('update')) {
                if (self.$route.params.id != undefined) {
                    self.showLoader();
                    self.loadlien();
                    $("#addAndContinuelienBtn").hide();
                    $("#addlienBtn").val("Update");
                    $("#lienHeader").text("Edit Lien");
                }
            } else {
                if (self.$route.params.id != 0) {
                    self.customerId = self.$route.params.id;
                    self.loadCustomeradd();
                }
            }

            var userObj = localStorage.getItem("user_obj");
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                self.loginID = userJson.id;
                EventBus.$emit(
                        "logged-in",
                        false,
                        userJson["first_name"],
                        userJson["last_name"],
                        userJson["email"]
                        );
            }
        },
        methods: {
            getCurrentDateTime(givenDate) {
              // console.log('givenDate==', givenDate);
              if(givenDate == '') {
                var today = new Date();
              } else {
                var today = new Date(givenDate);
              }


                var dd = today.getDate();
                var mm = today.getMonth()+1;
                var yyyy = today.getFullYear();

                var HH = today.getHours();
                var MM = today.getMinutes();
                var SS = today.getSeconds();

                if(dd<10)
                {
                    dd='0'+dd;
                }

                if(mm<10)
                {
                    mm='0'+mm;
                }

                if(HH<10)
                {
                    HH='0'+HH;
                }

                if(MM<10)
                {
                    MM='0'+MM;
                }

                if(SS<10)
                {
                    SS='0'+SS;
                }

                var date = mm+'-'+dd+'-'+yyyy;
                var time = HH + ":" + MM + ":" + SS;

                today = date + " " + time;
                return today;
            },
            onDateChage(selectedDates, dateStr, instance) {
                var self = this;
                //console.log("Date Change Called : " + self.due_date);
            },
            onPickerClose() {
                var self = this;
                //console.log("Picker Close Called : " + self.due_date);
            },
            getPermissions: function () {
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/user/permission",
                    type: "POST",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        if (data.status == 'success') {
                            self.cantAccessPage = false;
                            self.permissions = data.content;
                            let current_build = window.localStorage.getItem("build_version");
                            let latest_build = data.build;
                            if (current_build != undefined && current_build == '') {
                                localStorage.setItem("build_version", data.build);
                            } else if (current_build != latest_build) {
                                localStorage.setItem("build_version", data.build);
                                location.reload(true);
                            }
                            if (self.permissions.length > 0) {
                                for (var i = 0; i < self.permissions.length; i++) {
                                    if (self.permissions[i].name == 'can_add_new_lien') {
                                        self.cantAccessPage = true;
                                    }
                                }
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.cantAccessPage = false;
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }

                });
            },
            changedValue: function (value) {
                //console.log(value);
            },

            onSearch(search, loading) {
                var self = this;
                if (search.length > 2) {
                    loading(true);
                    self.loadCustomer(loading, search, this);
                }
            },
            onSearchTax(search, loading) {
                var self = this;
                if (search.length >= 1) {
                    loading(true);
                    self.loadTax(loading, search, this);
                }
            },
           
            onSearchUser(search, loading) {
                var self = this;
                if (search.length > 2) {
                    loading(true);
                    self.loadUser(loading, search, this);
                }
            },
            loadCustomer(loading, search, vm) {
                var self = this;

                $.ajax({
                    url: process.env.ROOT_API + "/get/customers",
                    type: "GET",
                    headers: {
                        Accept: "application/json",
                        "Access-Control-Allow-Origin": "*",
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        "Access-Control-Allow-Headers":
                                "Origin, Content-Type, Authorization,X-Requested-With",
                        "Cache-Control": "no-cache"
                    },
                    data: {
                        search: search
                    },
                    dataType: "json",
                    success: function (data) {
                        loading(false);
                        self.customerArr = data;
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },

            loadCustomeradd() {
                var self = this;

                $.ajax({
                    url: process.env.ROOT_API + "/get/customers",
                    type: "GET",
                    headers: {
                        Accept: "application/json",
                        "Access-Control-Allow-Origin": "*",
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        "Access-Control-Allow-Headers":
                                "Origin, Content-Type, Authorization,X-Requested-With",
                        "Cache-Control": "no-cache"
                    },
                    data: {
                        default: self.customerId
                    },
                    dataType: "json",
                    success: function (data) {
                        self.customer_id = {value: data[0].value, text: data[0].text};
                        self.customerArr = data;
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },

            loadUser(loading, search, vm) {
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/get/users",
                    type: "GET",
                    headers: {
                        Accept: "application/json",
                        "Access-Control-Allow-Origin": "*",
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        "Access-Control-Allow-Headers":
                                "Origin, Content-Type, Authorization,X-Requested-With",
                        "Cache-Control": "no-cache"
                    },
                    data: {
                        search: search,
                        type: 'collector',
                    },
                    dataType: "json",
                    success: function (data) {
                        loading(false);

                        self.userArr = data;
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },

            backshowlien() {
                var self = this;

                if (self.$route.path.includes('update')) {
                    if (self.$route.params.from != 0) {
                        self.$router.push("/customer/view/" + self.$route.params.from);
                    } else {
                        self.$router.push("/lien/list");
                    }
                } else {
                    if (self.$route.params.id != 0) {
                        self.$router.push("/customer/view/" + self.$route.params.id);
                    } else {
                        self.$router.push("/lien/list");
                    }
                }
            },
            isTooLarge(value) {
                // Convert the value to a number and check if it exceeds 1,000,000
                const numericValue = parseFloat(String(value).replace(',', ''));
                return numericValue > 1000000;
            },
            isValidLength(value) {
                // Remove decimal point and check length of numeric part
                const numericValue = String(value).replace('.', '').replace(/,/g, '');
                return numericValue.length >= 1 && numericValue.length <= this.allowedLength;
            },
            AddLien(flag) {
                var self = this;
                var amtError = false;
                self.amtErrors.required = false;
                self.amtErrors.notNumber = false;
                self.amtErrors.tooLarge = false;

                self.lienErr.tooLong = false;
                self.serialErr.tooLong = false;
                self.roErr.tooLong = false;
                // Check if the field is empty
                if (String(self.lien_amount).trim() === '') {
                    self.amtErrors.required = true;
                    amtError = true;
                } else if (!/^\d*\.?\d+$/.test(self.lien_amount)) {
                    // Check if the value is a valid number
                    self.amtErrors.notNumber = true;
                    amtError = true;
                } else if (self.isTooLarge(self.lien_amount)) {
                    // Check if the length is valid
                    self.amtErrors.tooLarge = true;
                    amtError = true;
                }

                if (!self.isValidLength(self.lien_number) && self.lien_number != ''){
                    self.lienErr.tooLong = true;
                    amtError = true;
                }
                if (!self.isValidLength(self.serial_number) && self.serial_number != ''){
                    self.serialErr.tooLong = true;
                    amtError = true;
                }
                if (!self.isValidLength(self.ro_number) && self.ro_number != ''){
                    self.roErr.tooLong = true;
                    amtError = true;
                }
                
                self.$validator.validate().then(result => {
                    if (result && !amtError) {
                        if (self.$route.path.includes('update')) {
                            if (self.$route.params.id) {
                                $("#addlienBtn").val("Updating ...");
                                $("#addlienBtn").prop("disabled", true);
                                // $("#addAndContinueCaseBtn").prop('disabled',true);
                                $("#Cancellien").prop("disabled", true);
                            } else {
                                if (flag == "Save and Continue") {
                                    $("#addAndContinuelienBtn").val("Saving ...");
                                    $("#addAndContinuelienBtn").prop("disabled", true);
                                    $("#addlienBtn").prop("disabled", true);
                                    $("#Cancellien").prop("disabled", true);
                                } else {
                                    $("#addlienBtn").val("Saving ...");
                                    $("#addlienBtn").prop("disabled", true);
                                    $("#addAndContinuelienBtn").prop("disabled", true);
                                    $("#Cancellien").prop("disabled", true);
                                }
                            }
                        } else {
                            if (flag == "Save and Continue") {
                                $("#addAndContinuelienBtn").val("Saving ...");
                                $("#addAndContinuelienBtn").prop("disabled", true);
                                $("#addlienBtn").prop("disabled", true);
                                $("#Cancellien").prop("disabled", true);
                            } else {
                                $("#addlienBtn").val("Saving ...");
                                $("#addlienBtn").prop("disabled", true);
                                $("#addAndContinuelienBtn").prop("disabled", true);
                                $("#Cancellien").prop("disabled", true);
                            }
                        }

                        var fields = $("#lienform").serializeArray();
                        // fields.push({name: "lien_amount", value: self.lien_amount});
                        fields.push({name: "customer_id", value: self.customer_id.value});
                        fields.push({name: "user_id", value: self.user_id.value});
                        // fields.push({name: "ro_number", value: self.ro_number });
                        fields.push({name: "status", value: self.status.value});
                        fields.push({name: "issue_date", value: self.issue_date});
                        fields.push({name: "expiry_date", value: self.expiry_date });

                        self.$validator.validateAll();
                        self.$validator.errors.clear();
                        if (self.$route.path.includes('update')) {
                            if (self.$route.params.id) {
                                fields.push({name: "id", value: self.$route.params.id});
                            } else {
                                fields.push({name: "id", value: 0});
                            }
                        } else {
                            fields.push({name: "id", value: 0});
                        }
                        self.showLoader();
                        $.ajax({
                            url: process.env.ROOT_API + "/lien/create",
                            type: "POST",
                            data: fields,
                            headers: {
                                Accept: "application/json",
                                "Access-Control-Allow-Origin": "*",
                                Authorization: "Bearer " + localStorage.getItem("api_token"),
                                "Access-Control-Allow-Headers":
                                        "Origin, Content-Type, Authorization,X-Requested-With",
                                "Cache-Control": "no-cache"
                            },
                            dataType: "json",
                            success: function (data) {
                                self.hideLoader();
                                if (self.$route.path.includes('update')) {
                                    if (self.$route.params.id) {
                                        $("#addlienBtn").val("Update");
                                        $("#addlienBtn").prop("disabled", false);
                                        // $("#addAndContinueCaseBtn").prop('disabled',true);
                                        $("#Cancellien").prop("disabled", false);
                                    } else {
                                        if (flag == "Save and Continue") {
                                            $("#addAndContinuelienBtn").val("Save and Continue");
                                            $("#addAndContinuelienBtn").prop("disabled", false);
                                            $("#addlienBtn").prop("disabled", false);
                                            $("#Cancellien").prop("disabled", false);
                                        } else {
                                            $("#addlienBtn").val("Save");
                                            $("#addlienBtn").prop("disabled", false);
                                            $("#addAndContinuelienBtn").prop("disabled", false);
                                            $("#Cancellien").prop("disabled", false);
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        $("#addAndContinuelienBtn").val("Save and Continue");
                                        $("#addAndContinuelienBtn").prop("disabled", false);
                                        $("#addlienBtn").prop("disabled", false);
                                        $("#Cancellien").prop("disabled", false);
                                    } else {
                                        $("#addlienBtn").val("Save");
                                        $("#addlienBtn").prop("disabled", false);
                                        $("#addAndContinuelienBtn").prop("disabled", false);
                                        $("#Cancellien").prop("disabled", false);
                                    }
                                }
                                if (data.status == "success") {
                                    // self.$router.push('/lien/list');

                                    if (flag == "Save and Continue") {
                                        $("html, body").animate({scrollTop: "0px"}, 500);
                                        $(".alert-success").parent().removeClass("hide");
                                        $(".alert-success").parent().addClass("show");
                                        self.other_reason= '';
                                        self.ptTaxId= '';
                                        self.svTaxId= '';
                                        self.lien_no= '';
                                        self.lien_reason= '';
                                        self.expiry_date= '';
                                        self.verf_date= '';
                                        self.lien_state= '';
                                        self.customer_id = '';
                                        self.user_id = '';
                                        self.customerArr = [];
                                        self.userArr = [];
                                        //$("#due_date").val("");
                                        if (self.$route.params.id != 0) {
                                            self.customerId = self.$route.params.id;
                                            self.loadCustomeradd();
                                        }
                                        setTimeout(function () {
                                            $(".alert-success").parent().removeClass("show");
                                            $(".alert-success").parent().addClass("hide");
                                        }, 5000);
                                    } else {
                                        self.backshowlien();
                                    }
                                } else {
                                    // $(".alert-danger").parent().removeClass('hide');
                                    // $(".alert-danger").parent().addClass('show');
                                    if (data.content.length > 0) {
                                        var err = "";
                                        for (var i = 0; i < data.content.length; i++) {
                                            err += data.content[i] + "<br>";
                                        }
                                        $("#errorMsg").html(err);
                                        $(".alert-danger").parent().removeClass("hide");
                                        $(".alert-danger").parent().addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").parent().removeClass("show");
                                            $(".alert-danger").parent().addClass("hide");
                                        }, 5000);
                                    }
                                }
                            },
                            error: function (jqXHR, exception) {
                                self.hideLoader();
                                if (self.$route.path.includes('update')) {
                                    if (self.$route.params.id) {
                                        $("#addlienBtn").val("Update");
                                        $("#addlienBtn").prop("disabled", false);
                                        // $("#addAndContinueCaseBtn").prop('disabled',true);
                                        $("#Cancellien").prop("disabled", false);
                                        $("#errorMsg").html(jqXHR.responseJSON.message);
                                        $(".alert-danger").parent().removeClass("hide");
                                        $(".alert-danger").parent().addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").parent().removeClass("show");
                                            $(".alert-danger").parent().addClass("hide");
                                        }, 5000);
                                    } else {
                                        if (flag == "Save and Continue") {
                                            $("#addAndContinuelienBtn").prop("disabled", false);
                                            $("#addAndContinuelienBtn").val("Save and Continue");
                                            $("#addlienBtn").prop("disabled", false);
                                            $("#Cancellien").prop("disabled", false);
                                            $("#errorMsg").html(jqXHR.responseJSON.message);
                                            $(".alert-danger").parent().removeClass("hide");
                                            $(".alert-danger").parent().addClass("show");
                                            self.other_reason= '';
                                            self.ptTaxId= '';
                                            self.svTaxId= '';
                                            self.lien_no= '';
                                            self.lien_reason= '';
                                            self.expiry_date= '';
                                            self.verf_date= '';
                                            self.lien_state= '';
                                            self.customer_id = '';
                                            self.user_id = '';
                                            self.customerArr = [];
                                            self.userArr = [];
                                            //$("#due_date").val("");
                                            if (self.$route.params.id != 0) {
                                                self.customerId = self.$route.params.id;
                                                self.loadCustomeradd();
                                            }
                                            setTimeout(function () {
                                                $(".alert-danger").parent().removeClass("show");
                                                $(".alert-danger").parent().addClass("hide");
                                            }, 5000);
                                        } else {
                                            $("#addlienBtn").val("Save");
                                            $("#addlienBtn").prop("disabled", false);
                                            $("#addAndContinuelienBtn").prop("disabled", true);
                                            $("#Cancellien").prop("disabled", false);
                                            $("#errorMsg").html(jqXHR.responseJSON.message);
                                            $(".alert-danger").parent().removeClass("hide");
                                            $(".alert-danger").parent().addClass("show");
                                            setTimeout(function () {
                                                $(".alert-danger").parent().removeClass("show");
                                                $(".alert-danger").parent().addClass("hide");
                                            }, 5000);
                                        }

                                        if (jqXHR.status == 0) {
                                            self.errorMsg = "Remote server can not be reachable";
                                        } else {
                                            //redirect to login page if user not authenticated
                                            if (jqXHR.status == 401) {
                                                //clear previous data
                                                localStorage.removeItem("user_obj");
                                                localStorage.removeItem("api_token");
                                                //EventBus.$emit("logged-in", true, "", "");
                                                self.$router.push("/login");
                                            }
                                            $("#errorMsg").html(jqXHR.responseJSON.message);
                                            $(".alert-danger").parent().removeClass("hide");
                                            $(".alert-danger").parent().addClass("show");
                                            setTimeout(function () {
                                                $(".alert-danger").parent().removeClass("show");
                                                $(".alert-danger").parent().addClass("hide");
                                            }, 5000);
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        $("#addAndContinuelienBtn").prop("disabled", false);
                                        $("#addAndContinuelienBtn").val("Save and Continue");
                                        $("#addlienBtn").prop("disabled", false);
                                        $("#Cancellien").prop("disabled", false);
                                        $("#errorMsg").html(jqXHR.responseJSON.message);
                                        $(".alert-danger").parent().removeClass("hide");
                                        $(".alert-danger").parent().addClass("show");
                                        self.other_reason= '';
                                        self.ptTaxId= '';
                                        self.svTaxId= '';
                                        self.lien_no= '';
                                        self.lien_reason= '';
                                        self.expiry_date= '';
                                        self.verf_date= '';
                                        self.lien_state= '';
                                        self.customer_id = '';
                                        self.user_id = '';
                                        self.customerArr = [];
                                        self.userArr = [];
                                        if (self.$route.params.id != 0) {
                                            self.customerId = self.$route.params.id;
                                            self.loadCustomeradd();
                                        }
                                        //$("#due_date").val("");
                                        setTimeout(function () {
                                            $(".alert-danger").parent().removeClass("show");
                                            $(".alert-danger").parent().addClass("hide");
                                        }, 5000);
                                    } else {
                                        $("#addlienBtn").val("Save");
                                        $("#addlienBtn").prop("disabled", false);
                                        $("#addAndContinuelienBtn").prop("disabled", true);
                                        $("#Cancellien").prop("disabled", false);
                                        $("#errorMsg").html(jqXHR.responseJSON.message);
                                        $(".alert-danger").parent().removeClass("hide");
                                        $(".alert-danger").parent().addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").parent().removeClass("show");
                                            $(".alert-danger").parent().addClass("hide");
                                        }, 5000);
                                    }

                                    if (jqXHR.status == 0) {
                                        self.errorMsg = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (jqXHR.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            //EventBus.$emit("logged-in", true, "", "");
                                            self.$router.push("/login");
                                        }
                                        $("#errorMsg").html(jqXHR.responseJSON.message);
                                        $(".alert-danger").parent().removeClass("hide");
                                        $(".alert-danger").parent().addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").parent().removeClass("show");
                                            $(".alert-danger").parent().addClass("hide");
                                        }, 5000);
                                    }
                                }
                            }
                        });
                    }
                });
            },

            loadlien() {
                var self = this;
                self.showLoader();
                $.ajax({
                    url: process.env.ROOT_API + "/lien/" + self.$route.params.id,
                    type: "GET",
                    headers: {
                        Accept: "application/json",
                        "Access-Control-Allow-Origin": "*",
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        "Access-Control-Allow-Headers":
                                "Origin, Content-Type, Authorization,X-Requested-With",
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        self.hideLoader();
                        self.created_at = self.getCurrentDateTime(data.content.created_at);;
                        self.updated_at = self.getCurrentDateTime(data.content.updated_at);
                        self.lien_amount = data.content.lien_amount;
                        self.lien_number = data.content.lien_number;
                        self.serial_number = data.content.serial_number;
                        self.ro_number = data.content.ro_number;
                        self.expiry_date = data.content.expiry_date;
                        self.issue_date = data.content.issue_date;
                        self.customer_id = {
                            value: data.content.cid,
                            text: data.content.first_name + " (" + data.content.cusid + ")"
                        };
                        self.user_id = {
                            value: data.content.uid,
                            text:
                                    data.content.user_firstname +
                                    " " +
                                    data.content.user_lastname/* +
                                        data.content[0].user_email*/
                        };
                        self.status = {
                            value: data.content.status,
                            text: self.formatString(data.content.status)
                        };

                        // console.log(data.content.updated_user_firstname);
                        self.u_firstName = data.content.updated_user_firstname;
                        self.u_lastName = data.content.updated_user_lastname;

                    },
                    error: function (jqXHR, exception) {
                        self.hideLoader();
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },
            formatString(data) {
                var self = this;
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            },
            menuSmall: function () {
                $(".opensidebar").show();
                $(".closesidebar").hide();
                $(".menu").addClass("menusmall");
                $(".sidemenu li a span,.legal").addClass("displaynone");
                $(".sidemenu li a i").addClass("displayicons");
                $(".sidebar").css({width: "70px"});
                $(".content").css({marginLeft: "70px"});
                $("html, body").animate({scrollTop: 0}, 10);
            },
            menuBig: function () {
                $(".opensidebar").hide();
                $(".closesidebar").show();
                $(".menu").removeClass("menusmall");
                $(".sidemenu li a span,.legal").removeClass("displaynone");
                $(".sidemenu li a i").removeClass("displayicons");
                $(".sidebar").css({width: "260px"});
                $(".content").css({marginLeft: "260px"});
                $("html, body").animate({scrollTop: 0}, 10);
            },
        }
    };
    EventBus.$on('logged-in', function (isLogin, fname, lname, email) {
        if (typeof (contex) != "undefined") {
            contex.isShowLoggedinfields = isLogin;
            contex.firstName = fname;
            contex.lastName = lname;
            contex.userName = email;
        }
    });
</script>



// WEBPACK FOOTER //
// src/components/lien/AddLien.vue